import React from "react";
import { TextField } from "components";
import { useExemptionsContext } from "../../ExemptionsContext";
import ButtonV2 from "elements/ButtonV2";

const CurrentEmployer = () => {
	const { next, specialFieldsValue, setSpecialFieldsValue } =
		useExemptionsContext();

	const handleSubmit = async () => {
		next();
	};

	const buttonDisabled = React.useMemo(() => {
		return !specialFieldsValue?.current_employer;
	}, [specialFieldsValue]);

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<div className="property-profile-question-card exemption-survey-card">
				<div className="property-profile-question-card-title-container">
					<p>Name of Current Employer</p>
				</div>
				<p className="exemption-question-card-subtitle sm">
					The county requires this information in order to approve the
					application.
				</p>

				<TextField
					required
					label="Current Employer"
					placeholder="Current Employer"
					containerClassName="exemptions-card-input"
					value={specialFieldsValue?.current_employer ?? ""}
					onChange={e => {
						setSpecialFieldsValue({ current_employer: e.target.value });
					}}
				/>
			</div>
			<ButtonV2 size="large" disabled={buttonDisabled} type="submit">
				Continue
			</ButtonV2>
		</form>
	);
};

export default CurrentEmployer;
